import { render, staticRenderFns } from "./ProjectTasksSearch.vue?vue&type=template&id=0f797c64"
import script from "./ProjectTasksSearch.vue?vue&type=script&lang=js"
export * from "./ProjectTasksSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports